<!--Payment Message-->
<div class="modal-header">
	<h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-footer p-0 pt-3">
	<button type="button" class="btn btn-primary" (click)="onClick()">OK</button>
	<button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">Close</button>
</div>